export default {
  case: '判案書',
  legis: '法例',
  other: '其他',
  regulations: '附屬法例',
  ordinances: '條例',
}